import type { Territory } from "$global-providers/config-provider/provider";
import { TERRITORY } from "$routes/_lib/constants";
import { defineMessage } from "react-intl";
import { date, string } from "yup";

export const addressLine = () => string().max(50);

export const dateOfBirthValidation = () =>
  date()
    .typeError(
      defineMessage({
        id: "validation.dob.mustBeValidDate",
        defaultMessage: "Please check the date is valid",
      }),
    )
    .max(
      // TODO: I wonder if this breaks if you pick today and forgot to remove the timestamp from the input
      new Date(),
      defineMessage({
        id: "validation.dob.max",
        defaultMessage: "Date of Birth must be in the past",
      }),
    )
    .min(
      new Date().getFullYear() - 121,
      defineMessage({
        id: "validation.dob.min",
        defaultMessage: "Date of Birth cannot exceed 121 years",
      }),
    );

const kenyaPhoneRegex = /^(?:254|\+254|0)?([17]{1}[0-9]{8})$/;
const nigeriaPhoneRegex = /^(?:234|\+234|0)?([0-9]{8,10})$/;
const pakistanPhoneRegex = /^(?:92|\+92|0)?([0-9]{7,10})$/;
export const liberiaPhoneRegex = /^(?:231|\+231|0)([1-9][0-9]{8})$/;

export const validatePhoneNumber = (
  phoneNumber: string,
  territory: Territory,
) => {
  switch (territory) {
    case TERRITORY.KENYA:
      return kenyaPhoneRegex.test(phoneNumber);
    case TERRITORY.NIGERIA:
      return nigeriaPhoneRegex.test(phoneNumber);
    case TERRITORY.PAKISTAN:
      return pakistanPhoneRegex.test(phoneNumber);
    case TERRITORY.LIBERIA:
      return liberiaPhoneRegex.test(phoneNumber);
    default:
      return kenyaPhoneRegex.test(phoneNumber);
  }
};

export const phoneNumberValidationMessage = (territory: Territory) => {
  switch (territory) {
    case TERRITORY.KENYA:
      return defineMessage({
        id: "patient.form.validation.phoneNumber.mustBeValidKenyanNumber",
        defaultMessage: "Please enter a valid phone number e.g. 0789012345",
      });
    case TERRITORY.NIGERIA:
      return defineMessage({
        id: "patient.form.validation.phoneNumber.mustBeValidNigerianNumber",
        defaultMessage: "Please enter a valid phone number: e.g. 070 12345678",
      });
    case TERRITORY.PAKISTAN:
      return defineMessage({
        id: "patient.form.validation.phoneNumber.mustBeValidPakistaniNumber",
        defaultMessage: "Please enter a valid phone number: e.g. 03001234567",
      });
    case TERRITORY.LIBERIA:
      return defineMessage({
        id: "patient.form.validation.phoneNumber.mustBeValidLiberianNumber",
        defaultMessage: "Please enter a valid phone number: e.g. 0770123456",
      });
    default:
      return defineMessage({
        id: "patient.form.validation.phoneNumber.mustBeValidNumber",
        defaultMessage: "Please enter a valid phone number e.g. 0789012345",
      });
  }
};
